import { Image } from 'load-image-react';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import * as React from 'react';
import { DirtyContext } from '../dirtyContext';
import classNames from './photoUploader.classNames';

export interface PhotoUploaderAttributes {
    imageDataUrls: string[];
    photoFiles: File[];
}

export interface PhotoUploaderActions {
    previewFiles(files: FileList) : void;
}

export type PhotoUploaderProps = PhotoUploaderAttributes & PhotoUploaderActions;

export const PhotoPreview = (dataUrl: string, index: number) => (
    <Image key={`photo_preview_${index}`} src={dataUrl} loadOptions={{contain: true, maxWidth: 400, maxHeight: 400}}/>
);

export const PhotoUploader = (props: PhotoUploaderProps) => {
    const { setDirty } = React.useContext(DirtyContext);
    const onFileChanges = (e: React.FormEvent<HTMLInputElement>) => {
        props.previewFiles(e.currentTarget.files);
        setDirty(true);
    };

    return (
        <Stack>
            {props.imageDataUrls.map(PhotoPreview)}
            <Label htmlFor='photoPicker' className={classNames().label}>
                <FontIcon iconName='camera' className={classNames().icon}/>
                <span>Upload photos</span>
            </Label>
            <input className={classNames().files} id='photoPicker' type='file' accept='image/*' multiple={true} onChange={onFileChanges}/>
        </Stack>
        );
};
